import type { Atom } from "@pdfking/tfunc"

/** A page path as one string, the key a page is looked up by. */
export const PathKey = (path: Atom[]): string => path.map(String).join("/")
